import { render, staticRenderFns } from "./SettingsCard.vue?vue&type=template&id=3a000b7c&scoped=true"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"
import style0 from "./SettingsCard.vue?vue&type=style&index=0&id=3a000b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a000b7c",
  null
  
)

export default component.exports